var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { delay } from '@xyo-network/sdk-xyo-js';
import { getLocalStorageObject, setLocalStorageObject } from '@xyo-network/sdk-xyo-react-js';
class InfoWrapper {
    constructor(localStorageName, value) {
        this._localStorageName = localStorageName;
        this._data = value !== null && value !== void 0 ? value : Object.create(null);
        this.load();
    }
    get data() {
        return this._data;
    }
    getSanitizedData() {
        return this._data;
    }
    save() {
        setLocalStorageObject(this._localStorageName, this._data);
        return this;
    }
    load() {
        this._data = getLocalStorageObject(this._localStorageName);
        return this;
    }
    clear() {
        localStorage.removeItem(this._localStorageName);
        return this;
    }
    valid() {
        return __awaiter(this, void 0, void 0, function* () {
            return (yield this.errors()).length === 0;
        });
    }
    errors() {
        return __awaiter(this, void 0, void 0, function* () {
            yield delay(0);
            return [];
        });
    }
}
export default InfoWrapper;
//# sourceMappingURL=InfoWrapper.js.map